import * as IF from "infrontjs";
import template from "./template.html";

/**
 * <sidebar-nav> — the SaaS Admin left navigation rail.
 * Renders the logo, grouped nav items and the help footer. It is a pure
 * presentational shell; <app-layout> wires the nav-item click/active behaviour
 * (the items live in the light DOM, so the parent's querySelectorAll reaches them).
 */
class SidebarNav extends HTMLElement
{
    constructor()
    {
        super();
        this._connected = false;
    }

    connectedCallback()
    {
        if ( false === this._connected )
        {
            this.app = IF.App.get();
            this.render();
            this._connected = true;
        }
    }

    render()
    {
        this.app.view.render( this, template, {} );
    }
}

customElements.define( "sidebar-nav", SidebarNav );
